export const ValidationMessages = {
  DURATION:
    'Request for Vacation must be at least 15 minutes and at most 16 hours duration.',
  BALANCE:
    'Please be sure you will accrue sufficient vacation (PTO/ETO) hours by the time of your request.',
  FLEXIBLE_BALANCE:
    'Request for Flexible Personal Days cannot be more than the Available Flexible Personal Day Balance.',
  FLOAT_BALANCE:
    'Float Hours requested cannot be more than the Available Float Balance.',
  FLEXIBLE_DURATION:
    'Request for Flexible Personal Days cannot exceed 16 hours duration. Please revise your request.',
  FLEXIBLE_MIN_TWO_HOURS:
    'Request for Flexible Personal Days must be at least 2 hours duration.',
  FLOAT_DURATION:
    'Request for Float hours must be at least 15 minutes and at most 16 hours duration.',
  DURATION_AND_FLEXIBLE:
    'Multiple duration errors detected. Request for Vacation must be at least 15 minutes and at most 16 hours duration. Request for Flexible Personal Days must be at least 2 hours and at most 16 hours duration. Please revise your request.',
  OTHER_SUBTYPE_REQUIRED: 'Other sub type is required',
  OTHER_DURATION:
    'Request for Other types of time off must be at least 15 minutes and at most 16 hours duration.',
  TOTAL_HOURS_EXCEED_MAX:
    'The total hours requested per day cannot exceeds 16 hours.',
  CHOICE_RANK_REQUIRED: 'Choice/Rank required.',
  NO_HOURS_ENTERED:
    'In a full day request, you need to enter hours for a Time Off Request Type (Vacation, Float, Flexible Personal Day, Other).',
  NO_HOURS_ENTERED_PARTIAL_DAY:
    'In a partial day request, you need to enter hours for a Time Off Request Type (Vacation, Float, Flexible Personal Day, Other).',
  EDUCATION_COMMENT_REQUIRED: 'Required for education requests',
  REQUEST_DATES_EXCEED_8_DAY_GAP:
    'There are dates in your request that are separated by more than 8 days.',
  FLOAT_BALANCE_UNAVAILABLE: 'Float balance is not available.',
  FLOAT_BALANCE_INFO:
    'Please be sure your Float balance is sufficient for any request that includes Float hours.',
  PARTIAL_DAY_TIME_ORDER:
    'In a partial day request, Start Time needs to be earlier than End Time.',
  PARTIAL_DAY_HOURS_EXCEED_DURATION:
    'Hours entered is greater than time duration selected.',
  PARTIAL_DAY_HOURS_LESS_THAN_DURATION:
    'Hours entered is less than time duration selected.',
  OVERRIDE_NOT_AVAILABLE:
    'Override to approved not available due to existing full or 3 partial day request',
  REVISE_REQUEST: 'Please revise your request.',
  PARTIAL_DAY_OVERLAP:
    'Partial day requests overlap. Please revise your request.',
}

export default ValidationMessages
